define('drops/pushNotificationReceiver/pushNotificationReceiver',[
    'jquery', 
    'underscore',
    'lq/main',
    'lq/drop',
    'lq/cordovaPushNotifications',
    'lq/webPushNotifications'
], function ($, _, main, Drop, cordovaPushNotifications, webPushNotifications) {
    'use strict';
    
    function PushNotificationReceiver(options) {
        Drop.call(this, $('<div />'), options);
    };

    Drop.extend(PushNotificationReceiver);

    PushNotificationReceiver.typeName = 'PushNotificationReceiver';

    PushNotificationReceiver.prototype.postRender = function() {
        this.setup();
    };

    PushNotificationReceiver.prototype.setup = function () {
        if (window.cordova)
            document.addEventListener('deviceready', this.initializeForCordova.bind(this), false);
        else if (main.areWebNotificationsEnabled())
            this.piping.eventing.subscribe('PageLoad', this.initializeForWeb.bind(this));
    };

    PushNotificationReceiver.prototype.initializeForWeb = function () {
        var notificationsClient = webPushNotifications.get(this.piping.application.userId);

        if (notificationsClient.hasReceivedNotifications()) {
            var notifications = notificationsClient.getAllReceivedNotifications();

            // wait until all drops are loaded before we trigger this event
            this.piping.eventing.subscribe('PageLoad', this.handleNotifications.bind(this, notifications));
        }

        notificationsClient.addListener(this.handleNotification.bind(this));
    };

    PushNotificationReceiver.prototype.initializeForCordova = function () {
        if (!window.PushNotification)
            return;

        var notificationsClient = cordovaPushNotifications.get(this.piping.application.userId);

        if (notificationsClient.hasReceivedNotifications()) {
            var notifications = notificationsClient.getAllReceivedNotifications();

            // wait until all drops are loaded before we trigger this event
            this.piping.eventing.subscribe('PageLoad', this.handleNotifications.bind(this, notifications));
        }

        notificationsClient.addListener(this.handleNotification.bind(this));
    };

    PushNotificationReceiver.prototype.handleNotifications = function(notifications) {
        _.each(notifications, this.handleNotification.bind(this));
    };

    PushNotificationReceiver.prototype.handleNotification = function (notification) {
        var self = this;
        _.each(_.keys(notification), function (prop) {
            if (prop !== 'foreground' && prop !== 'coldstart' && prop !== 'dismissed' )
                self.piping.parameters.locals.setValue(prop, notification[prop]);
        });

        if (notification.foreground)
            this.triggerEventIfEnabled('foregroundNotificationReceived');
        else
            this.triggerEventIfEnabled('backgroundNotificationReceived');

    };

    return PushNotificationReceiver;
});
